export const IntercomJournalSurveyIds = Object.freeze({
    English: 850599,
    Danish: 857810,
    Norwegian: 857785,
    Swedish: 857818,
    Finnish: 857821,
});
